import { ToastContainer } from 'react-toastify';
import './App.css';
import 'react-quill-new/dist/quill.snow.css';
import 'quill-table-better/dist/quill-table-better.css';
import 'quill-resize-module/dist/resize.css';
import Navigation from './navigation';
import { useSelector } from 'react-redux';
import useIdleLogout from './hooks/useIdleLogout';

function App() {
  // const accessToken = useSelector((state: any) => state.auth?.access_token);
  // const isLoggedIn = useSelector((state: any) => state.auth?.loginSuccess);

  /** OLD-CODE-BELOW
    const isLoggedIn = useSelector(
      (state: any) => state.userLogin?.loginSuccess
    );
    // // 🔐 Auto logout on inactivity
    // useIdleLogout(!!isLoggedIn);
  */
  /** NEW-CODE-BELOW ADDING BECAUSE WHEN TAB CLOSE AND COME AFTER SOMETIME OR NEXT DAY IT WILL LOGOUT DUE TO IN ACTIVITY */
  const token = localStorage.getItem("token");
  useIdleLogout(!!token);

  return (
    <>
      <ToastContainer />
      <Navigation />
    </>
  );
}

export default App;
